import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Bio.module.css';
import LanguageContext from '../context/LanguageContext';
import { myBioInfoUA } from '../../data/bioInfo';
import Tooltip from './Tooltip';
import { certificationData } from '../../data/certificatesData';

export default function Bio({
    classNameContacts,
    myBioInfo,
    dots,
    age,
    residence,
    languages,
    level,
    freelance,
}) {
    const { language } = useContext(LanguageContext);
    const [copied, setCopied] = useState(null);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

    const copy = async (value, key, event) => {
        try {
            await navigator.clipboard.writeText(
                value.replace(/(-|\(|\))/g, '')
            );
            const x = event.clientX;
            const y = event.clientY;
            const { innerWidth, innerHeight } = window;
            const tooltipWidth = 80;
            const tooltipHeight = 30;
            const adjustedX =
                x + 10 + tooltipWidth > innerWidth
                    ? x - 10 - tooltipWidth
                    : x + 10;
            const adjustedY =
                y + 10 + tooltipHeight > innerHeight
                    ? y - 10 - tooltipHeight
                    : y;
            setCopied(key);
            setTooltipPos({ x: adjustedX, y: adjustedY });
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    };

    useEffect(() => {
        if (copied !== null) {
            const timer = setTimeout(() => {
                setCopied(null);
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [copied]);

    return (
        <ul className={cn(styles.bio, classNameContacts)}>
            {(language === 'en' ? myBioInfo : myBioInfoUA)
                .filter(
                    (e) =>
                        e.key !== age &&
                        e.key !== residence &&
                        e.key !== languages &&
                        e.key !== freelance
                )
                .map((el) => (
                    <li key={el.key} className={cn(styles.bioLine)}>
                        <div className={cn(styles.key)}>
                            {el.key}
                            {dots}
                        </div>
                        <div
                            className={cn(styles.value)}
                            onClick={(e) => copy(el.value, el.key, e)}
                        >
                            <span>{el.value}</span>
                            {copied === el.key && (
                                <Tooltip text='Copied!' position={tooltipPos} />
                            )}
                        </div>
                    </li>
                ))}
            {level !== 'contacts' && (
                <li className={cn(styles.bioLine)}>
                    <div className={cn(styles.key)}>
                        {language === 'en' ? 'English level' : 'Рівень англ.'}

                        {dots}
                    </div>
                    <div className={cn(styles.linkValue)}>
                        <a
                            href={certificationData[3].url}
                            target='_blank'
                            rel='noreferrer'
                            className={cn(styles.link)}
                        >
                            {language === 'en'
                                ? 'intermediate strong'
                                : 'середній впевнений'}
                        </a>
                    </div>
                </li>
            )}
        </ul>
    );
}
